module.exports = __webpack_public_path__ + "13685372945d816a2b474fc082fd9aaa.ttf";